<template>
  <div class="reset">
    <template v-if="isEmailSent">
      <h2>Search Password</h2>

      <div class="reset-wrap">
        <p class="txt">{{ $t('recoverPassword.sentResetLink', { email: model.email }) }}</p>
        <div class="btns">
          <p>
            <router-link :to="{ name: 'SignIn' }" class="btn_1">{{ $t('common.confirm') }}</router-link>
          </p>
          <p>
            {{ $t('recoverPassword.isNotSent') }} <span @click="onResendLinkClick">{{ $t('recoverPassword.resend') }}</span>
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <h2>Search Password</h2>
      <div class="reset-wrap">
        <table>
          <tr>
            <th aria-label="userId">ID</th>
            <td>
              <input type="text"
                     name="userId"
                     aria-labeledby="userId"
                     placeholder="example@example.com"
                     maxlength="60"
                     ref="email"
                     v-model.trim="model.email" />
              <strong class="wrong"
                      v-if="errors.email">* {{ $t(errors.email) }}</strong>
            </td>
          </tr>
        </table>
        <div class="btns">
          <button type="button"
                  class="btn_1 pw_search_btn"
                  @click="onRecoveryClick">Search Password</button>
          <router-link :to="{ name: 'SignIn' }"
                       class="btn_3">Cancel</router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import accountApi from '@/api/account'
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'RecoverPassword',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      errors: {},
      isEmailSent: false,
      isRetry: false,
      model: {
        email: null
      }
    }
  },
  methods: {
    recover () {
      this.errors = {}
      accountApi.recoverPassword(this.model).then(response => {
        if (response.data.result === 'success') {
          if (this.isRetry) {
            modalEvent.openToast('recoverPassword.emailResent')
          } else {
            this.isEmailSent = true
          }
        }
      }).catch(err => {
        this.handleAjaxError(err, this.errors)

        if (this.errors.signInFailed) {
          modalEvent.openDialog({
            message: 'recoverPassword.noMatchedAccountMessage',
            ok: 'recoverPassword.signUp',
            cancel: 'recoverPassword.reEnter'
          }).then(result => {
            if (result) {
              this.$router.push({ name: 'SignUp' })
            } else {
              this.$refs.email.focus()
            }
          })
        }
      })
    },
    onRecoveryClick () {
      this.recover()
    },
    onResendLinkClick () {
      this.isRetry = true
      this.recover()
    }
  }
}
</script>
<style lang="scss" scoped>
.reset {
  width: 1194px;
  padding: 0 15px;
  margin: 15px auto 0;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding: 40px 0 13px;
    display: inline-block;
    margin: 0 10px;
  }

  .reset-wrap {
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 20px 20px 50px;
  }

  .txt {
    margin: 30px auto 40px;
    color: #666666;
    text-align: center;
  }

  table {
    width: auto;
    margin: 30px auto 10px;
  }

  th {
    vertical-align: top;
    line-height: 36px;
    color: #666666;
    width: 100px;
    padding-left: 20px;
  }

  td {
    position: relative;
    padding-bottom: 40px;

    input {
      width: 300px;
    }

    .wrong {
      position: absolute;
      left: 0;
      bottom: 15px;
      font-size: 12px;
      font-weight: normal;
      color: #ec0047;
      white-space: nowrap;
    }
  }

  .btns {
    text-align: center;

    p:last-child {
      margin-top: 30px;
      font-size: 14px;

      span {
        cursor: pointer;
        color: #ec0047;
      }
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand { /* for IE */
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/guest/RecoverPassword.vue